import React from "react";

const InsertPhoto = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.625 4.25H6.375C5.2014 4.25 4.25 5.2014 4.25 6.375V27.625C4.25 28.7986 5.2014 29.75 6.375 29.75H27.625C28.7986 29.75 29.75 28.7986 29.75 27.625V6.375C29.75 5.2014 28.7986 4.25 27.625 4.25Z"
      stroke="#141516"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7502 16.2913C14.7062 16.2913 16.2918 14.7057 16.2918 12.7497C16.2918 10.7937 14.7062 9.20801 12.7502 9.20801C10.7942 9.20801 9.2085 10.7937 9.2085 12.7497C9.2085 14.7057 10.7942 16.2913 12.7502 16.2913Z"
      stroke="#141516"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6848 18.5717C20.263 17.7978 21.4292 17.8169 21.9818 18.6093L28.1973 27.5227C28.8521 28.4618 28.1801 29.7497 27.0352 29.7497H11.3335L19.6848 18.5717Z"
      stroke="#141516"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(InsertPhoto);
